import React from 'react';
import { AcademicCapIcon } from '@heroicons/react/24/solid';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="flex flex-col items-center space-y-4">
            {/* Logo */}
            <div className="flex items-center space-x-2">
              <div className="bg-gradient-to-r from-primary-600 to-primary-800 p-1.5 rounded-lg">
                <AcademicCapIcon className="h-5 w-5 text-white" />
              </div>
              <span className="text-lg font-bold gradient-text">MBA Admissions Simulator</span>
            </div>
            
            {/* Description */}
            <p className="text-gray-600 text-center max-w-md">
              Get personalized insights into your MBA application chances at top business schools.
            </p>
            
            {/* Links */}
            <div className="flex items-center space-x-6 text-sm text-gray-500">
              <span>Built for aspiring MBA students</span>
              <span>•</span>
              <span>School-specific evaluations</span>
              <span>•</span>
              <span>AI-powered insights</span>
            </div>
            
            {/* Copyright */}
            <div className="pt-4 border-t border-gray-200 w-full">
              <p className="text-center text-sm text-gray-500">
                © {new Date().getFullYear()} MBA Admissions Simulator. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 